import React from 'react';

const InvestmentPrice = ({ investment_price }) => {
  const { splitup } = investment_price;
  const TotalInvestmentPrice = investment_price[Object.keys(investment_price)[1]];
  const splitupEntries = Object.entries(splitup);

  return (
    <div className="wg-property single-property-nearby d-flex justify-content-center">
      <div className="container">
        <div className="wg-title text-11 fw-6 text-color-heading">Investment Price</div>
        <div className="flex-column box-nearby gap-4">
          <ul className="box-benefits d-flex flex-column gap-2">
            {splitupEntries.map(([title, value], index) => (
              <li key={index} className="item-benefit d-flex border-bottom py-4">
                <div className="d-flex row justify-content-center w-100">
                  <div className="col-6">
                    <p className="fw-7 label text-4 whitespace-nowrap">{title}</p>
                  </div>
                  <div className="col-6">
                    <p className="text-end mt-2">{value}</p>
                  </div>
                </div>
              </li>
            ))}

            <li className="item-benefit d-flex border-bottom py-4">
              <div className="d-flex row justify-content-center w-100">
                <div className="col-6">
                  <h5 className="fw-5 label whitespace-nowrap">
                    {Object.keys(investment_price)[1]} 
                  </h5>
                </div>
                <div className="col-6">
                  <h5 className="text-end mt-2">{TotalInvestmentPrice}</h5>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default InvestmentPrice;
